import Vector from "../tipos/vector";

const APEX_CHART_BAR = "bar";
const APEX_CHART_LINE = "line";

class MetConstants {
    constructor() {
        this.VAR_NAME_PRECIPITACION_5MIN = "Precipitación 5 minutal";
        this.VAR_NAME_PRECIPITACION_HORARIA = "Precipitación horaria";
        this.VAR_NAME_R3 = "R3";

        this.VAR_ID_PRECIPITACION_5MIN = 122;
        this.VAR_ID_PRECIPITACION_HORARIA = 94;
        this.VAR_ID_R3 = 46;

        this.ID_PERIODICIDAD_5MIN = 3;
        this.ID_PERIODICIDAD_HORARIA = 7;

        // ----------------------------
        // ----- Ids de variables -----
        // ----------------------------

        // Temperatura
        this.VAR_ID_TEMPAIRE_1H_INST = 47;
        this.VAR_ID_TEMPAIRE_10M_PROM = 144;
        this.VAR_ID_TEMPAIRE_10M_MAX = 145;
        this.VAR_ID_TEMPAIRE_10M_MIN = 146;
        this.VAR_ID_TEMPAIRE_1H_PROM = 113;
        this.VAR_ID_TEMPAIRE_1H_MIN = 107;
        this.VAR_ID_TEMPAIRE_1H_MAX = 106;
        this.VAR_ID_TEMPPTOROCIO_1H_INST = 59;

        // Presión
        this.VAR_ID_PRESATMEST_1H_INST = 43;
        this.VAR_ID_PRESATMMAR_1H_INST = 45;
        this.VAR_ID_PRESATMEST_10M_PROM = 157;
        this.VAR_ID_PRESATMMAR_10M_PROM = 148;

        // Humedad Relativa
        this.VAR_ID_HUMRELATIVA_1H_INST = 25;
        this.VAR_ID_HUMRELATIVA_10M_PROM = 147;

        // Precipitacion
        this.VAR_ID_PRECIP_1H_ACUM = 94;
        this.VAR_ID_PRECIP_5M_ACUM = 122;
        this.VAR_ID_PRECIPR3_24H_ACUM = 46;

        // Intensidad de viento
        this.VAR_ID_INTVIENTO_1H_INST = 29;
        this.VAR_ID_INTVIENTO_10M_PROM = 149;
        this.VAR_ID_INTVIENTO_10M_MAX = 156;
        this.VAR_ID_INTVIENTO_1H_MAX = 105;
        this.VAR_ID_INTRAFAGA_1H_INST = 28;

        // Dirs viento
        this.VAR_ID_DIRVIENTO_1H_INST = 8;
        this.VAR_ID_DIRVIENTO_10M_MAX = 155;
        this.VAR_ID_DIRVIENTO_10M_PROM = 150;

        // Nubosidad
        this.VAR_ID_COBERTURA_NUBES_TOTAL = 38;
        this.VAR_ID_COBERTURA_NUBES_BAJAS = 1;
        this.VAR_ID_COBERTURA_NUBES_MEDIAS = 1;
        this.VAR_ID_COBERTURA_NUBES_ALTAS = 1;

        // Visibilidad
        this.VAR_ID_VISIBILIDAD = 74;

        // Tiempo presente
        this.VAR_ID_TIEMPO_PRESENTE_PRIMARIO_1H_INST = 67;
        this.VAR_ID_TIEMPO_PRESENTE_SECUNDARIO_1H_INST = 68;

        // Arrays de ids
        this.idsTemperaturas = [
            this.VAR_ID_TEMPAIRE_1H_INST,
            this.VAR_ID_TEMPAIRE_10M_PROM,
            this.VAR_ID_TEMPAIRE_10M_MAX,
            this.VAR_ID_TEMPAIRE_10M_MIN,
            this.VAR_ID_TEMPAIRE_1H_PROM,
            this.VAR_ID_TEMPAIRE_1H_MIN,
            this.VAR_ID_TEMPAIRE_1H_MAX,
            this.VAR_ID_TEMPPTOROCIO_1H_INST,
        ];
        this.idsPresAtm = [
            this.VAR_ID_PRESATMEST_1H_INST,
            this.VAR_ID_PRESATMMAR_1H_INST,
            this.VAR_ID_PRESATMEST_10M_PROM,
            this.VAR_ID_PRESATMMAR_10M_PROM,
        ];
        this.idsHumRelativa = [
            this.VAR_ID_HUMRELATIVA_1H_INST,
            this.VAR_ID_HUMRELATIVA_10M_PROM,
        ];
        this.idsPrecip = [
            this.VAR_ID_PRECIP_1H_ACUM,
            this.VAR_ID_PRECIP_5M_ACUM,
            this.VAR_ID_PRECIPR3_24H_ACUM,
        ];

        this.idsIntViento = [
            this.VAR_ID_INTVIENTO_1H_INST,
            this.VAR_ID_INTRAFAGA_1H_INST,
            this.VAR_ID_INTVIENTO_10M_PROM,
            this.VAR_ID_INTVIENTO_10M_MAX,
            this.VAR_ID_INTVIENTO_1H_MAX,
        ];

        this.idsDirViento = [
            this.VAR_ID_DIRVIENTO_1H_INST,
            this.VAR_ID_DIRVIENTO_10M_PROM,
            this.VAR_ID_DIRVIENTO_10M_MAX,
        ];

        this.idsVisibilidad = [this.VAR_ID_VISIBILIDAD];

        this.idsNubosidad = [
            this.VAR_ID_COBERTURA_NUBES_TOTAL,
            this.VAR_ID_COBERTURA_NUBES_BAJAS,
            this.VAR_ID_COBERTURA_NUBES_MEDIAS,
            this.VAR_ID_COBERTURA_NUBES_ALTAS,
        ];

        this.idsTiempoPresente = [
            this.VAR_ID_TIEMPO_PRESENTE_PRIMARIO_1H_INST,
            this.VAR_ID_TIEMPO_PRESENTE_SECUNDARIO_1H_INST,
        ];

        // -------------------------------
        // ----- Valores Vectoriales -----
        // -------------------------------

        this.varsVectoriales = {};
        let v = new Vector(
            [
                this.VAR_ID_DIRVIENTO_1H_INST,
                this.VAR_ID_INTVIENTO_1H_INST,
                this.VAR_ID_INTRAFAGA_1H_INST,
            ],
            ["D", "V", "R"],
            true
        );
        this.varsVectoriales[this.VAR_ID_INTVIENTO_1H_INST] = v;
        this.varsVectoriales[this.VAR_ID_DIRVIENTO_1H_INST] = v;
        this.varsVectoriales[this.VAR_ID_INTRAFAGA_1H_INST] = v;

        v = new Vector(
            [this.VAR_ID_DIRVIENTO_10M_PROM, this.VAR_ID_INTVIENTO_10M_PROM],
            ["D", "V", "R"],
            true
        );
        this.varsVectoriales[this.VAR_ID_INTVIENTO_10M_PROM] = v;
        this.varsVectoriales[this.VAR_ID_DIRVIENTO_10M_PROM] = v;

        v = new Vector(
            [this.VAR_ID_DIRVIENTO_10M_MAX, this.VAR_ID_INTVIENTO_10M_MAX],
            ["D", "V", "R"],
            true
        );
        this.varsVectoriales[this.VAR_ID_INTVIENTO_10M_MAX] = v;
        this.varsVectoriales[this.VAR_ID_DIRVIENTO_10M_MAX] = v;

        v = new Vector([
            this.VAR_ID_TIEMPO_PRESENTE_PRIMARIO_1H_INST,
            this.VAR_ID_TIEMPO_PRESENTE_SECUNDARIO_1H_INST,
        ]);
        this.varsVectoriales[this.VAR_ID_TIEMPO_PRESENTE_PRIMARIO_1H_INST] = v;
        this.varsVectoriales[this.VAR_ID_TIEMPO_PRESENTE_SECUNDARIO_1H_INST] =
            v;

        // ---------------------------------
        // ----- Graficas de variables -----
        // ---------------------------------

        this.apexChartsType = {};

        this.apexChartsType[this.VAR_ID_TEMPAIRE_1H_INST] = APEX_CHART_LINE;
        this.apexChartsType[this.VAR_ID_TEMPAIRE_10M_PROM] = APEX_CHART_LINE;
        this.apexChartsType[this.VAR_ID_TEMPAIRE_10M_MAX] = APEX_CHART_LINE;
        this.apexChartsType[this.VAR_ID_TEMPAIRE_10M_MIN] = APEX_CHART_LINE;
        this.apexChartsType[this.VAR_ID_TEMPAIRE_1H_PROM] = APEX_CHART_LINE;
        this.apexChartsType[this.VAR_ID_TEMPAIRE_1H_MAX] = APEX_CHART_LINE;
        this.apexChartsType[this.VAR_ID_TEMPAIRE_1H_MIN] = APEX_CHART_LINE;

        this.apexChartsType[this.VAR_ID_PRESATMEST_1H_INST] = APEX_CHART_LINE;
        this.apexChartsType[this.VAR_ID_PRESATMMAR_1H_INST] = APEX_CHART_LINE;
        this.apexChartsType[this.VAR_ID_PRESATMEST_10M_PROM] = APEX_CHART_LINE;
        this.apexChartsType[this.VAR_ID_PRESATMEST_10M_PROM] = APEX_CHART_LINE;

        this.apexChartsType[this.VAR_ID_HUMRELATIVA_1H_INST] = APEX_CHART_LINE;
        this.apexChartsType[this.VAR_ID_HUMRELATIVA_10M_PROM] = APEX_CHART_LINE;

        this.apexChartsType[this.VAR_ID_INTVIENTO_1H_INST] = APEX_CHART_LINE;
        this.apexChartsType[this.VAR_ID_INTRAFAGA_1H_INST] = APEX_CHART_LINE;
        this.apexChartsType[this.VAR_ID_INTVIENTO_10M_PROM] = APEX_CHART_LINE;
        this.apexChartsType[this.VAR_ID_INTVIENTO_10M_MAX] = APEX_CHART_LINE;
        this.apexChartsType[this.VAR_ID_INTVIENTO_1H_MAX] = APEX_CHART_LINE;

        this.apexChartsType[this.VAR_ID_PRECIP_1H_ACUM] = APEX_CHART_BAR;
        this.apexChartsType[this.VAR_ID_PRECIP_5M_ACUM] = APEX_CHART_BAR;
        this.apexChartsType[this.VAR_ID_PRECIPR3_24H_ACUM] = APEX_CHART_BAR;

        // --------------------------------
        // ----- Grupos de estaciones -----
        // --------------------------------

        this.GRUPO_ESTACIONES_ID_EMASG3 = 102;
        this.GRUPO_ESTACIONES_ID_EMASG3_LABORATORIO = 247;

        // -------------------------------
        // ----- Grupos de variables -----
        // -------------------------------

        this.GRUPO_VARIABLES_ID_EMASG3 = "EMAs G3";

        // -----------------------------------
        // ----- Gerencias de estaciones -----
        // -----------------------------------

        this.gerencias = {};
        this.gerencias.inumet = "INUMET";
        this.gerencias.inmet = "BR";
        this.gerencias.inia = "INIA";
        this.gerencias.smn = "SMN";
        this.gerencias.caisa = "CAISA";

        this.gerenciasOrdenDefecto = {};
        this.gerenciasOrdenDefecto[this.gerencias.inumet] = 0;
        this.gerenciasOrdenDefecto[this.gerencias.inmet] = 1;
        this.gerenciasOrdenDefecto[this.gerencias.inia] = 2;

        this.gerenciasNombres = {};
        this.gerenciasNombres[this.gerencias.inumet] = "INUMET";
        this.gerenciasNombres[this.gerencias.inmet] = "INMET";
        this.gerenciasNombres[this.gerencias.inia] = "INIA";
    }
}

let metConstants = new MetConstants();

export { metConstants as default, APEX_CHART_BAR, APEX_CHART_LINE };
